function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Queue = /*#__PURE__*/ function() {
    "use strict";
    function Queue() {
        _class_call_check(this, Queue);
        this._first = null;
        this._last = null;
    }
    _create_class(Queue, [
        {
            // Shows us the first item in the list
            key: "first",
            value: function first() {
                return this._first && this._first.value;
            }
        },
        {
            // Shows us the last item in the list
            key: "last",
            value: function last() {
                return this._last && this._last.value;
            }
        },
        {
            key: "push",
            value: function push(value) {
                // An item stores an id and the provided value
                var item = typeof value.next !== 'undefined' ? value : {
                    value: value,
                    next: null,
                    prev: null
                };
                // Deal with the queue being empty or populated
                if (this._last) {
                    item.prev = this._last;
                    this._last.next = item;
                    this._last = item;
                } else {
                    this._last = item;
                    this._first = item;
                }
                // Return the current item
                return item;
            }
        },
        {
            // Removes the item that was returned from the push
            key: "remove",
            value: function remove(item) {
                // Relink the previous item
                if (item.prev) item.prev.next = item.next;
                if (item.next) item.next.prev = item.prev;
                if (item === this._last) this._last = item.prev;
                if (item === this._first) this._first = item.next;
                // Invalidate item
                item.prev = null;
                item.next = null;
            }
        },
        {
            key: "shift",
            value: function shift() {
                // Check if we have a value
                var remove = this._first;
                if (!remove) return null;
                // If we do, remove it and relink things
                this._first = remove.next;
                if (this._first) this._first.prev = null;
                this._last = this._first ? this._last : null;
                return remove.value;
            }
        }
    ]);
    return Queue;
}();
export { Queue as default };
